export enum ExperimentIds {
    // do not remove this is permanent exp for splitting users into segments
    SPLIT_INTO_TWO_SEGMENTS = "webtest_split_into_two_segments",
    FEMALE_PILATES_WEB_FUNNEL = "webtest_fempilates_feb24",
    USE_NEW_APPLE_PAY_FLOW = "webtest_new_apple_pay_flow_mar24",
    WEIGHT_PREDICTOR = "webtest_weight_pred_v1.0",
    NEW_UPGRADE_PRICES = "webtest_new_upgrade_prices_may24",
    UPSELL_NUTRITION_BOOK = "webtest_upsell_bundle_scannutr",
    MALE_STRENGTH_SCORE = "webtest_strength_score_may24",
    NEW_PAYMENT_VERSION = "webtest-palta-new-sdk-2",
    MUSCLE_GAIN_BENEFITS = "webtest_muscle_gain_benefits_may24",
    WEIGHT_PREDICTOR_V2 = "webtest_weight_pred_v2.0",
    MALE_MUSCLE_GROUP_VISUALIZATION = "webtest_muscle_group_visualization_jun24",
    BODY_SCAN_1ST_QUESTION = "webtest_body_scan_1st_question",
    BODY_SCAN_TO_SUB = "webtest_body_scan_to_sub_take2_jun24",
    WTP_RESEARCH = "webtest_WTPresearch_jun24",
    SHORT_STRICT_PAYWALL = "webtest_short_strict_paywall_jun24",
    DISABLE_PREVENT_DUPLICATE_FLOW = "disable_prevent_duplicate_flow",
    SHORT_FUNNEL = "webtest_short_funnel_jun24",
    BODY_SCAN_AS_GIFT = "webtest_body_scan_as_gift_jun24",
    AGE_RESTRICTION = "webtest_age_restriction_jun24",
    REMOVE_UPGRADE_FLOW = "webtest_remove_upgrade_flow_jus24",
}

export const enum ExperimentVariants {
    CONTROL = "control",
    TEST = "test",
    TEST_1 = "test_1",
    TEST_2 = "test_2",
    TEST_3 = "test_3",
    NOT_ALLOCATED = "not_allocated",
    SEGMENT_A = "segment_A",
    SEGMENT_B = "segment_B",
}

export const TEST_VARIANTS = [
    ExperimentVariants.TEST,
    ExperimentVariants.TEST_1,
    ExperimentVariants.TEST_2,
    ExperimentVariants.TEST_3,
];
